module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-logical-statement"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.statement.code) + "\n  " + _vm._s(_vm.statement.description) + "\n  "), _c('hrms-logical-statement', {
    attrs: {
      "listFields": _vm.listFields,
      "nowLang": _vm.nowLang
    },
    model: {
      value: (_vm.statement),
      callback: function($$v) {
        _vm.statement = $$v
      },
      expression: "statement"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56234724!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoLogicalStatement.vue
// module id = 3777
// module chunks = 1